const Logo = () => {
  return (
    <svg >
      <path d="M96.41,80.34c0,16.16-12.15,28.66-27.29,28.66c-6.19,0-11.35-1.61-15.6-4.35v3.21H37.59V35.51l15.93-9.05v29.69  c4.24-2.75,9.41-4.35,15.6-4.35C84.25,51.79,96.41,64.41,96.41,80.34 M80.7,80.34c0-8.03-5.96-15.02-14.22-15.02  c-4.7,0-9.4,1.6-12.96,6.31v17.54c3.56,4.82,8.26,6.42,12.96,6.42C74.74,95.59,80.7,88.48,80.7,80.34" />
      <path d="M112.1,101.39c0,4.2-3.41,7.61-7.61,7.61c-4.2,0-7.61-3.41-7.61-7.61c0-4.2,3.41-7.61,7.61-7.61  C108.7,93.78,112.1,97.19,112.1,101.39" />
    </svg>
  )
}

export default Logo